<div class="pageNotFound">
  <img
    ngSrc="../../../assets/images/pageNotFound.png"
    style="width: 175px; height: 175px;position: relative"
    alt=""
    priority
    fill/>
  <div>
    <h1>{{ "error.404" | translate }}</h1>
    <div>{{ "error.pageNotFound" | translate }}</div>
    <button class="btn btn-primary" (click)="goBack()">
      {{ "global.returnBack" | translate }}
    </button>
  </div>
</div>
